import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=45aff6ea&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45aff6ea')) {
      api.createRecord('45aff6ea', component.options)
    } else {
      api.reload('45aff6ea', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=45aff6ea&", function () {
      api.rerender('45aff6ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QEot06hkMm3Y/JS/videoIframe.vue"
export default component.exports